import navRouter from './navRouter'
export default [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/mainPage',
        component: () =>
            import(
                /* webpackChunkName: 'mainPage' */ '../components/pages/mainPage/mainPage.vue'
            ),
        children: [...navRouter],
    },
    //产品宣传册
    {
        path: '/productDoc',
        component: () =>
            import(
                /* webpackChunkName: 'productDoc' */ '../components/pages/views/home/productDoc.vue'
            ),
    },
    {
        path: '/index.html',
        redirect: '/home',
    },
]
